import { Dispatch, AnyAction } from "redux";
import { dispatchActionError } from "../../common/actions/actionErrorHandler";
import { CustomerPreferences } from "../types/customer";
import { actionTypeKeys } from "./actionTypeKeys";
import CustomersApi from "../api/customersApi";
import InternalCustomerPrefsApi from "src/internal/api/internalCustomerPrefsApi";

const loadCustomerPreferencesSuccess = (preferences: CustomerPreferences): AnyAction => {
  return {
    type: actionTypeKeys.LOAD_CUSTOMER_PREFERENCES_SUCCESS,
    preferences
  };
};

const updateCustomerPreferencesSuccess = (preferences: CustomerPreferences): AnyAction => {
  return {
    type: actionTypeKeys.CUSTOMER_PREFERENCES_UPDATED_SUCCESS,
    preferences
  };
};

export const getCustomerPreferences = (customerId: number) => {
  return async (dispatch: Dispatch) => {
    try {
      const preference = await CustomersApi.getCustomerPreferences(customerId);
      dispatch(loadCustomerPreferencesSuccess(preference));
    } catch (error) {
      dispatchActionError(error, dispatch);
    }
  };
};

export const getDefaultCustomerPreferences = () => {
  return async (dispatch: Dispatch) => {
    try {
      const preference = await InternalCustomerPrefsApi.getDefaultPrefs();
      dispatch(
        loadCustomerPreferencesSuccess({
          ...preference,
          preferredEmail: "",
          preferredPhone: ""
        })
      );
    } catch (error) {
      dispatchActionError(error, dispatch);
    }
  };
};

export const updateCustomerPreferences = (preferences: CustomerPreferences) => {
  return async (dispatch: Dispatch) => {
    try {
      const updatedPrefs = await CustomersApi.patchCustomerPreferences(preferences);
      dispatch(updateCustomerPreferencesSuccess(updatedPrefs));
    } catch (error) {
      dispatchActionError(error, dispatch);
    }
  };
};
